import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=5e046e44&scoped=true&"
import script from "./upload-file.vue?vue&type=script&lang=ts&"
export * from "./upload-file.vue?vue&type=script&lang=ts&"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=5e046e44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e046e44",
  null
  
)

export default component.exports